import { render, staticRenderFns } from "./ageChart.vue?vue&type=template&id=1cd9e7e8"
import script from "./ageChart.vue?vue&type=script&lang=js"
export * from "./ageChart.vue?vue&type=script&lang=js"
import style0 from "./ageChart.vue?vue&type=style&index=0&id=1cd9e7e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports